import { useState, useEffect } from "react";
import { useAgentInstructions } from "../contexts/AgentInstructionsContext";
import MKBox from "components/MKBox";
import Container from "@mui/material/Container";
import CircularProgress from "@mui/material/CircularProgress";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import MdTiptap from "components/MdTiptap"; // Updated import
import MKButton from "components/MKButton";
import { useNavigate } from "react-router-dom";
import useAdminAgentService from "../hooks/useAdminAgentService";

function AgentInstructionsForm() {
  const { agentNumber, agentInstructions, loading } = useAgentInstructions();
  const { updateAgentInstructions } = useAdminAgentService();

  const [content, setContent] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [dirty, setDirty] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);

  const SNACKBAR_DURATION = 6000;
  const navigate = useNavigate();

  /* ---------- helpers ---------- */
  const showAlert = (severity, message) => {
    if (severity === "error") setError(message);
    if (severity === "success") setSuccess(message);
    setOpenAlert(true);
  };

  const handleCloseAlert = () => setOpenAlert(false);

  const handleContentChange = (val) => {
    setDirty(true);
    setContent(val);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(content);
    const response = await updateAgentInstructions(agentNumber, content);
    if (response.success) {
      setDirty(false);
      showAlert("success", "Instructies bijgewerkt.");
    } else {
      showAlert("error", response.error || "Onbekende fout bij opslaan.");
    }
  };

  const handleCancel = () => {
    if (dirty) {
      const confirm = window.confirm("Weet je zeker dat je de instructies wilt annuleren?");
      if (confirm) {
        navigate(-1);
      }
    } else {
      navigate(-1);
    }
  };

  useEffect(() => {
    console.log(agentInstructions);
    setContent(agentInstructions);
  }, [agentInstructions]);

  if (loading) {
    return (
      <MKBox component="section" py={12}>
        <Container>
          <MKBox display="flex" justifyContent="center" alignItems="center" height="400px">
            <CircularProgress size={100} />
          </MKBox>
        </Container>
      </MKBox>
    );
  }

  return (
    <>
      <Card sx={{ width: "100%" }}>
        <MKBox component="form" autoComplete="off" onSubmit={handleSubmit} p={3} width="100%">
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <MdTiptap
                value={content}
                onChange={handleContentChange}
                error={error}
                outputFormat="html" // You can change this to "markdown" if needed
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <MKButton
                type="button"
                variant="outlined"
                color="dark"
                fullWidth
                onClick={handleCancel}
              >
                Annuleren
              </MKButton>
            </Grid>
            <Grid item xs={12} md={6}>
              <MKButton type="submit" variant="gradient" color="dark" fullWidth disabled={!!error}>
                Opslaan
              </MKButton>
            </Grid>
          </Grid>
        </MKBox>
      </Card>

      {/* Snackbar-based feedback */}
      <Snackbar open={openAlert} autoHideDuration={SNACKBAR_DURATION} onClose={handleCloseAlert}>
        <Alert
          onClose={handleCloseAlert}
          severity={error ? "error" : "success"}
          sx={{ width: "100%" }}
        >
          {error || success}
        </Alert>
      </Snackbar>
    </>
  );
}

export default AgentInstructionsForm;
